import type { LocationQueryValue } from 'vue-router'

export const downloadBlob = (blob: Blob, fileName: string) => {
  const url = window.URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = url
  link.download = fileName
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
  window.URL.revokeObjectURL(url)
}

export const getWeekNumber = (date: Date) => {
  const startOfYear = new Date(date.getFullYear(), 0, 1)
  const diffInDays = Math.floor(
    (date.getTime() - startOfYear.getTime()) / (24 * 60 * 60 * 1000)
  )

  return Math.ceil((diffInDays + startOfYear.getDay() + 1) / 7)
}

export const getDateTimeISO = (value: Date) => {
  const offsetMinutes = new Date().getTimezoneOffset()
  const offsetMs = offsetMinutes * 60 * 1000
  const newDate = new Date(value.getTime() - offsetMs)
  return newDate.toISOString()
}

export const getDateTimeISODate = (value?: Date | null) => {
  if (!value) return value
  return getDateTimeISO(value).split('T')[0]
}

export const getDateTimeISOTime = (value?: Date | null) => {
  if (!value) return value
  return getDateTimeISO(value).split('T')[1]
}

export const roundToNearest30 = (value: Date) => {
  const minutes = value.getMinutes()

  if (minutes < 15) {
    value.setMinutes(0, 0, 0)
  } else if (minutes < 45) {
    value.setMinutes(30, 0, 0)
  } else {
    value.setHours(value.getHours() + 1, 0, 0, 0)
  }

  return value
}

export const setupHeaders = (headers: Headers) => {
  const { currentOrganization } = useOrganization()

  if (currentOrganization.value) {
    if (Array.isArray(headers)) {
      headers.push(['X-Organization-Id', String(currentOrganization.value.id)])
    } else if (headers instanceof Headers) {
      headers.set('X-Organization-Id', String(currentOrganization.value.id))
    }
  }

  return headers
}

export function toNumber<TResult = number>(
  value?: LocationQueryValue | LocationQueryValue[] | string | number,
  defaultValue?: number
): TResult {
  defaultValue = defaultValue || 0
  if (!value) return defaultValue as TResult
  value = Array.isArray(value) ? value[0] : value
  const number = Number(value)
  return isNaN(number) ? (defaultValue as TResult) : (number as TResult)
}
